import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { catchError } from "rxjs/operators";
import { AuthService } from "../../authentication/services/auth.service";
import { APP_SETTINGS } from "../models/backofficeConfiguration";
import { ErrorHandlerService } from "./errorHandler.service";

declare let FXStreetAuth: any;

@Injectable()
export class ExecuteService {
  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private errorHandler: ErrorHandlerService
  ) {}

  public Execute(
    method: string,
    url: string,
    params?: HttpParams,
    body?: object
  ): Observable<any> {
    const options = {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
      params,
      body,
    };

    return this.http.request(method, url, options);
  }

  public ExecuteWithLocalAccessToken(
    method: string,
    url: string,
    params?: HttpParams,
    responseType: any = "json"
  ): Observable<any> {
    const auth = FXStreetAuth.Authorization.getInstance({
      authorizationUrl: APP_SETTINGS.AuthorizationI3TokenUrl,
    });
    return Observable.fromPromise(auth.getTokenPromise()).mergeMap((token) => {
      let tokenResult: any = token;
      let httpOptions = {
        headers: {
          Authorization:
            tokenResult.token_type + " " + tokenResult.access_token,
        },
        params,
        responseType,
      };

      return this.http
        .request("get", url, httpOptions)
        .pipe(
          catchError(
            this.errorHandler.handleError<object[]>("AssetsCalculation", [])
          )
        );
    });
  }

  public ExecuteWithToken(
    method: string,
    url: string,
    params?: HttpParams,
    body?: object,
    responseType: any = "json"
  ): Observable<any> {
    var token = this.authService.getToken();
    let options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      }),
      params,
      responseType,
      body,
    };

    return this.http.request(method, url, options);
  }

  public ExecuteWithApiToken(
    method: string,
    url: string,
    params?: HttpParams,
    body?: object | string,
    responseType: any = "json"
  ): Observable<any> {
    var token = APP_SETTINGS.WebVitalsApiToken;
    let options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "fxs-api-token": token,
      }),
      params,
      responseType,
      body,
    };

    return this.http.request(method, url, options);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/executeService.service.ts